import p from "./objectWithoutPropertiesLoose.js";
function a(t, o) {
  if (t == null)
    return {};
  var i = p(t, o), e, r;
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    for (r = 0; r < n.length; r++)
      e = n[r], !(o.indexOf(e) >= 0) && (!Object.prototype.propertyIsEnumerable.call(t, e) || (i[e] = t[e]));
  }
  return i;
}
export {
  a as default
};
//# sourceMappingURL=objectWithoutProperties.js.map
